import {Suspense, useEffect, useState, lazy} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {useIntl} from 'react-intl'
import QRCodeScanner from '../_metronic/layout/components/header/QRCode'
import NetworkDetector from './components/NetworkDetector'
//import moment from 'moment'
//import 'moment/locale/en-gb'
//import 'moment/locale/fr'
//import 'moment/locale/ar'

const App = () => {
  const intl = useIntl()
  useEffect(() => {
    const body = document.getElementsByTagName('html')[0]
    if (intl.locale === 'ar') {
      body.setAttribute('direction', 'rtl')
      body.setAttribute('dir', 'rtl')
      body.setAttribute('style', 'direction: rtl')
    } else {
      body.removeAttribute('dir')
      body.removeAttribute('direction')
      body.removeAttribute('style')
    }
  }, [intl.locale])

  const CSS = lazy(() => import('./routing/CSS'))
  const RTL = lazy(() => import('./routing/RTL'))

  return (
    <>
      <Suspense fallback={<LayoutSplashScreen />}>
        {intl.locale === 'ar' && <RTL />}
        {intl.locale !== 'ar' && <CSS />}
        <NetworkDetector>
          <LayoutProvider>
            <Outlet />
            <MasterInit />
          </LayoutProvider>
        </NetworkDetector>
      </Suspense>
    </>
  )
}

export {App}
